enum RouteEnum {
  Home = "/",
  Dashboard = "/Dashboard",
  Login = "/login",
  Extractpdf ="/invoice",
  Invoice = "/invoice/:id",
}

export default RouteEnum;
